import { initializeApp, getApps } from 'firebase/app'
import { FirebaseApp } from '@firebase/app-types'
import { getAuth } from 'firebase/auth'
import {
  initializeFirestore,
  useFirestoreEmulator as addEmulator,
} from 'firebase/firestore'

declare global {
  interface Window {
    Cypress?: unknown
  }
}

// The `FirebaseApp` that comes from `firebase/app` is different than the
// one that `getFirestore()` wants (which comes from `@firebase/app-types`).
// So in the meantime, we're asserting the desired type.
const firebaseApp =
  typeof window !== 'undefined' && getApps.length === 0
    ? (initializeApp({
        apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
        appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
        measurementId: process.env.NEXT_PUBLIC_GA_ID,
        projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
      }) as FirebaseApp)
    : undefined

export const auth = firebaseApp ? getAuth(firebaseApp) : undefined

export const firestore = firebaseApp
  ? initializeFirestore(
      firebaseApp,
      // see: https://github.com/cypress-io/cypress/issues/6350
      window.Cypress ? { experimentalForceLongPolling: true } : {},
    )
  : undefined

if (firestore && window.location.hostname === 'localhost') {
  addEmulator(firestore, 'localhost', 8080)
}

export default firebaseApp
